import DefineDocumentWrite from './define-document-write.view';

export default DefineDocumentWrite;
